<style lang="scss"
       module>
@import '../brand/brandColors.variables.scss';

.mainArea {
  composes: mainContent from '../brand/structure.scss';
}

.wrapper {
  composes: pageContainer from '../brand/structure.scss';
  composes: standard from '../brand/typography.scss';
}

.headline {
  composes: standard from '../brand/typography.scss';
  font-size: 3.6rem;
  color: $blue-dark;
  width: 100%;
  text-align: center;
  margin: 4.8rem auto;
}

.panels {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 3.2rem;
}
</style>
<template>
  <div :class="$style.mainArea">
    <div :class="$style.wrapper">
      <h1 :class="$style.headline">GO2 Signature Builder</h1>
      <div :class="$style.panels">
        <Panel
          v-for="(division, index) in divisions"
          :division="division"
          :key="index"/>
      </div>
    </div>
  </div>
</template>

<script>
/* Vue Components */
import Panel from '../components/panel/Panel.vue';
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */
import divisions from '../data/data';

export default {
  name: 'Home',
  components: {
    Panel,
  },
  data() {
    return {
      divisions,
    };
  },
};
</script>
